var React = require('react');

function MyEvents (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2 2.042l8.69 2.444c.355.1.643.48.643.847V6a.928.928 0 0 1-.643.847L2 9.292V13a.666.666 0 1 1-1.333 0V.999A.666.666 0 1 1 2 1v1.043zm0 1.393l.011 4.468L10 5.67 2 3.435z","fill":"#A9B0B7","fillRule":"evenodd"}));
}

MyEvents.defaultProps = {"width":"12","height":"14","viewBox":"0 0 12 14"};

module.exports = MyEvents;

MyEvents.default = MyEvents;
